import withController from 'components/common/form-controlled/with-controller.hoc';
import withLabel from 'components/common/form-controlled/with-label.hoc';
import withTooltip from 'components/common/form-controlled/with-tooltip.hoc';
import type { TextInputProps } from 'components/common/input-components/text-input';
import TextInput from 'components/common/input-components/text-input';

const ControlledTextInput = withLabel(withController<TextInputProps>(withTooltip(TextInput)));
export default ControlledTextInput;
